import React, { useMemo, useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BookingField from './BookingField';

const FORMSPREE_FORM_ID = 'myezgaop';

const initialForm = {
  name: '',
  email: '',
  company: '',
  date: '',
  time: '',
  message: ''
};

function Contact() {
  const [form, setForm] = useState(initialForm);
  const [honey, setHoney] = useState('');
  const [, setSubmitted] = useState(false);
  const [formspreeState, handleSubmitFormspree] = useForm(FORMSPREE_FORM_ID);

  const minimumDate = useMemo(() => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split('T')[0];
  }, []);

  const updateField = (event) => {
    const { name, value } = event.target;
    setSubmitted(false);
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (honey) return;
    await handleSubmitFormspree({ ...form, _gotcha: honey });
  };

  return (
    <section className="section contact" id="contact">
      <div className="contact-intro">
        <span className="section-label">Book a discovery call</span>
        <h2>Let’s find your<br />next opportunity.</h2>
        <p>
          Choose a convenient time to talk with GEN IT SOLUTIONS INC about your
          goals, workflows, and where intelligent systems can create value.
        </p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="contact-fields">
          <BookingField label="Your name">
            <input
              name="name"
              value={form.name}
              onChange={updateField}
              placeholder="Jane Smith"
              autoComplete="name"
              required
            />
          </BookingField>

          <BookingField label="Email address">
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={updateField}
              placeholder="jane@company.com"
              autoComplete="email"
              required
            />
          </BookingField>

          <BookingField label="Company" fullWidth>
            <input
              name="company"
              value={form.company}
              onChange={updateField}
              placeholder="Your company"
              autoComplete="organization"
              required
            />
          </BookingField>

          <BookingField label="Preferred date">
            <input
              type="date"
              name="date"
              value={form.date}
              onChange={updateField}
              min={minimumDate}
              required
            />
          </BookingField>

          <BookingField label="Preferred time">
            <select
              name="time"
              value={form.time}
              onChange={updateField}
              required
            >
              <option value="">Select a time</option>
              <option value="9:00 AM">9:00 AM</option>
              <option value="10:30 AM">10:30 AM</option>
              <option value="1:00 PM">1:00 PM</option>
              <option value="2:30 PM">2:30 PM</option>
              <option value="4:00 PM">4:00 PM</option>
            </select>
          </BookingField>

          <BookingField label="What would you like to discuss?" fullWidth>
            <textarea
              name="message"
              value={form.message}
              onChange={updateField}
              placeholder="Tell us briefly about your goals or challenge..."
              required
            />
          </BookingField>

          <div hidden aria-hidden="true">
            <label>
              Leave this field empty:
              <input
                type="text"
                name="_gotcha"
                tabIndex={-1}
                value={honey}
                onChange={(event) => setHoney(event.target.value)}
              />
            </label>
          </div>
        </div>

        <ValidationError
          prefix="Form"
          field="form"
          errors={formspreeState.errors}
          className="form-message form-message--error"
        />

        {formspreeState.succeeded && (
          <p className="form-message form-message--success" role="status">
            Your discovery call request has been sent. We&rsquo;ll get back to
            you within one business day to confirm your preferred time.
          </p>
        )}

        {formspreeState.submitting && (
          <p className="form-message" role="status">
            Sending your request...
          </p>
        )}

        <button
          className="button button-primary contact-submit"
          type="submit"
          disabled={formspreeState.submitting}
        >
          {formspreeState.submitting ? 'Sending...' : 'Request discovery call'}
          <SafeIcon icon={FiIcons.FiArrowUpRight} aria-hidden="true" />
        </button>
      </form>
    </section>
  );
}

export default Contact;